import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-poker-3",
  "use": "icon-si-glyph-poker-3-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-poker-3\" id=\"icon-si-glyph-poker-3\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>621</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M11.494,1 L5.412,1 C4.082,1 3,1.097 3,2.444 L3,15.545 C3,16.893 4.082,16.99 5.412,16.99 L11.494,16.99 C12.824,16.99 13.906,16.892 13.906,15.545 L13.906,2.444 C13.906,1.097 12.824,1 11.494,1 L11.494,1 Z M9.402,10.998 L9.062,10.998 L9.062,13.062 L7.906,13.062 L7.906,10.998 L7.648,10.998 C6.607,11.123 5.854,11.297 5.854,9.983 C5.854,8.336 8.49,5.031 8.49,5.031 C8.49,5.031 11.125,8.336 11.125,9.983 C11.125,11.297 10.443,11.123 9.402,10.998 L9.402,10.998 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-poker-3.svg
// module id = mIe1
// module chunks = 62